import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './TableContainer.module.scss';

const TableContainer = forwardRef(({ className, ...props }, ref) => {
  return <div {...props} ref={ref} className={cn(styles.root, className)} />;
});

export default TableContainer;
